var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"},[_c('dt',{class:{
      'text-sm font-medium text-gray-500': !_vm.highlight,
      'text-sm font-semibold text-gray-800': _vm.highlight,
    }},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('dd',{staticClass:"mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2",class:{
      'font-semibold': _vm.highlight,
    }},[_vm._t("default"),(_vm.value)?[_c('span',{domProps:{"innerHTML":_vm._s(_vm.value)}})]:(!_vm.$slots.default)?[_c('CTypo',{staticClass:"italic text-gray-500",attrs:{"el":"span"}},[_vm._v(_vm._s(_vm.noValueLabel))])]:_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }